export default __webpack_public_path__ + "static/media/login-background.ae2c1cd7.jpg";